import { render } from "./HeroiconsSolidCheck.vue?vue&type=template&id=661e464c"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCheck.vue"]])

export default __exports__